import { defineMessages } from 'react-intl';

export default defineMessages({
    quotePageQuoteSummaryCardTitle: {
        id: 'wmic.pe-capability-quoteandbind-pa-react.pages.pa-quote-page.Quote Summary',
        defaultMessage: 'Quote Summary'
    },
});
